"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const RightsholderCatalogRegistrationDrafts_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderCatalogRegistrationDrafts"));
const ViewWorkInternalScene_1 = __importDefault(require("@Scenes/WorkScenes/ViewWorkInternalScene"));
const ViewDraftScene_1 = __importDefault(require("@Scenes/WorkScenes/ViewDraftScene"));
const Match_1 = __importDefault(require("@Scenes/RightsholderScene/MatchClaim/Match"));
const react_1 = __importDefault(require("react"));
const editwork_1 = __importDefault(require("@App/routes/rightsholder/editwork"));
const navigation_1 = __importDefault(require("@App/navigation"));
const match_history_1 = __importDefault(require("@App/routes/rightsholder/match-history"));
const permissions_1 = require("@Const/permissions");
const PermissionCheck_1 = __importDefault(require("@Components/PermissionCheck"));
const draft_1 = require("@App/routes/rightsholder/editwork/draft");
const fetch_type_enum_1 = require("@App/kit/components/WorkItemV2/fetch-type-enum");
const RightsholderDashboard_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderDashboard"));
const RightsholderCatalogLayout_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderCatalog/RightsholderCatalogLayout"));
const RightsholderCatalogSearch_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderCatalog/RightsholderCatalogSearch"));
const RightsholderOverclaimSearch_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimSearch"));
const RightsholderOverclaimLayout_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderOverclaim/RightsholderOverclaimLayout"));
const ClaimWizardFlow_1 = __importDefault(require("@Scenes/RightsholderScene/MatchClaim/ClaimWizardFlow"));
const OverclaimView_1 = __importDefault(require("@Scenes/RightsholderScene/RightsholderOverclaim/OverclaimView"));
const route_1 = require("@App/navigation/route");
const registration_history_1 = require("@App/routes/rightsholder/registration-history");
const royalties_1 = require("@App/routes/rightsholder/royalties");
const maintenance_1 = require("@App/routes/rightsholder/maintenance");
const createRightsholderRootRoutes = () => {
    const editWorkRoutes = (0, editwork_1.default)(route_1.EDIT_WORK_ROUTE);
    const editDraftRoutes = (0, draft_1.createEditDraftRoutes)(route_1.EDIT_DRAFT_ROUTE);
    const matchHistoryRoutes = (0, match_history_1.default)();
    const registrationHistoryRoutes = (0, registration_history_1.createRegistrationHistoryRoutes)();
    const royaltiesRoutes = (0, royalties_1.createRoyaltiesRoutes)();
    const maintenanceRoutes = (0, maintenance_1.createMaintenanceRoutes)();
    return {
        path: '',
        children: [
            {
                path: route_1.RIGHTSHOLDER_SUB_ROUTES.summary,
                element: react_1.default.createElement(RightsholderDashboard_1.default, null),
            },
            {
                path: '',
                element: (react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.manage_works], orIsInternal: true, reRouteLocation: navigation_1.default.home.root() },
                    react_1.default.createElement(RightsholderOverclaimLayout_1.default, null))),
                children: [
                    {
                        path: route_1.RIGHTSHOLDER_SUB_ROUTES.overclaim.root,
                        element: react_1.default.createElement(RightsholderOverclaimSearch_1.default, null),
                    },
                    {
                        path: route_1.RIGHTSHOLDER_SUB_ROUTES.overclaim.view,
                        element: react_1.default.createElement(OverclaimView_1.default, null),
                    },
                ],
            },
            registrationHistoryRoutes,
            {
                path: route_1.RIGHTSHOLDER_SUB_ROUTES.drafts.root,
                element: (react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.manage_works], orIsInternal: true, reRouteLocation: navigation_1.default.home.root() },
                    react_1.default.createElement(RightsholderCatalogRegistrationDrafts_1.default, null))),
            },
            {
                path: route_1.RIGHTSHOLDER_SUB_ROUTES.drafts.viewDraft,
                element: react_1.default.createElement(ViewDraftScene_1.default, null),
            },
            editWorkRoutes,
            {
                path: '',
                element: (react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.view_works], orIsInternal: true, reRouteLocation: navigation_1.default.home.root() },
                    react_1.default.createElement(RightsholderCatalogLayout_1.default, null))),
                children: [
                    {
                        path: route_1.RIGHTSHOLDER_SUB_ROUTES.catalog.root,
                        element: react_1.default.createElement(RightsholderCatalogSearch_1.default, null),
                    },
                    {
                        path: route_1.RIGHTSHOLDER_SUB_ROUTES.catalog.viewWork,
                        element: react_1.default.createElement(ViewWorkInternalScene_1.default, { fetchType: fetch_type_enum_1.FetchType.HFA }),
                    },
                ],
            },
            {
                path: route_1.RIGHTSHOLDER_SUB_ROUTES.claimingTool,
                element: (react_1.default.createElement(PermissionCheck_1.default, { requiredPermissions: [permissions_1.PERMISSIONS.CATALOG_PERMISSIONS.view_works], orIsInternal: true, reRouteLocation: navigation_1.default.home.root() },
                    react_1.default.createElement(ClaimWizardFlow_1.default, null))),
            },
            {
                path: route_1.RIGHTSHOLDER_SUB_ROUTES.matchingTool,
                element: react_1.default.createElement(Match_1.default, null),
            },
            matchHistoryRoutes,
            editDraftRoutes,
            ...royaltiesRoutes,
            ...maintenanceRoutes,
            {
                path: '',
                element: react_1.default.createElement(RightsholderDashboard_1.default, null),
            },
        ],
    };
};
exports.default = createRightsholderRootRoutes;
